import React from 'react';
import { connect } from 'react-redux';
import ReactComponentWrapper from 'ReactComponentWrapper';

class ComponentForUpdatingStoreFromBackbone extends React.Component {
    componentDidMount() {
        const { actionToTrigger, param, dispatch } = this.props;
        dispatch(actionToTrigger(param));
    }

    componentDidUpdate(prevProps) {
        const { param, actionToTrigger, dispatch } = this.props;
        if (param !== prevProps.param) {
            dispatch(actionToTrigger(param));
        }
    }

    render() {
        return <ReactComponentWrapper {...this.props} />;
    }
}

export default connect()(ComponentForUpdatingStoreFromBackbone);
